const toastConfig =
{
    position: "top-center",
    duration: 3500,
    action: [],
    closeOnSwipe: true,
    color: "#9b3c6e",
    className: "notif-class",
    action: [],
};

export default toastConfig;